import { Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { NZ_MODAL_DATA } from 'ng-zorro-antd/modal';

@Component({
  selector: 'app-add-attachments',
  standalone: false,
  templateUrl: './add-attachments.component.html',
  styleUrl: './add-attachments.component.less'
})
export class AddAttachmentsComponent {
  uploadedFiles : File[] = [];
  SelectAll:boolean = false;
  maxFileSize = 50;//50 MB =51200 in KB, 
  maxFileUploadCount : number = 15;
  canUploadFileCount : number = 0;
  alreadyUploadFileCount : number = 0;
  readonly nzModalData = inject(NZ_MODAL_DATA);  
  @Output() onFilesUploadClicked: EventEmitter<any> = new EventEmitter<any>();
  constructor() { }

  ngOnInit() {
    this.uploadedFiles = this.nzModalData.uploadedFiles;
    this.alreadyUploadFileCount = this.nzModalData.alreadyUploadFileCount;    
    this.canUploadFileCount = this.maxFileUploadCount - this.alreadyUploadFileCount;
  }
  handleFileInputOptimized(selectedFile: FileList) {
    Array.from(selectedFile).forEach(file => {
      const fileSizeMB = file.size / (1024 * 1024);
      const isFileSizeValid = fileSizeMB <= this.maxFileSize;
      const isFileUnique = !this.uploadedFiles.some(item => item.name.toLowerCase() === file.name.toLowerCase());
      const canAddMoreFiles = this.uploadedFiles.length < this.canUploadFileCount;

      if (isFileSizeValid && isFileUnique && canAddMoreFiles) {
        this.uploadedFiles.push(file);
      }
    });

    this.uploadFile();
  }
  handleFileInput(event: Event) {
    const input = event.target as HTMLInputElement; // Cast EventTarget to HTMLInputElement
    const selectedFile = input.files; // Access the files property

    if (!selectedFile) {
      console.error('No files selected');
      return;
    }
    for (let index = 0; index < selectedFile.length; index++) {
      var file = selectedFile[index];
      if (file != null) {
          var fileSize = ((file.size / 1024) / 1024);
          if (fileSize <= this.maxFileSize && this.uploadedFiles.length < this.canUploadFileCount) {
            if(this.uploadedFiles.length == 0) 
              this.uploadedFiles.push(file);
            else
            {
              let isFound = this.uploadedFiles.filter(item => item.name.toLowerCase() === file.name.toLowerCase());
              if(isFound.length == 0)
              this.uploadedFiles.push(file);
            }
          }
      }
    }
    
    this.uploadFile();
  }
  uploadFile()
  {
    this.onFilesUploadClicked.emit(this.uploadedFiles);
  }

  removeFile(index: any)
  {
    this.uploadedFiles.splice(index,1);
    this.uploadFile();
  }

}
